import classNames from 'classnames';
import Stack from '@mui/material/Stack/Stack';
import Typography from '@mui/material/Typography/Typography';
import { ColorDot, LegendContainer } from './styled/color-dot';

type LegendItemProps = {
  label: string;
  color: string;
};

type ChartLegendProps = {
  items: LegendItemProps[];
  dotSize?: number;
  fontSize?: number;
  spaceBetween?: boolean;
};

export const ChartLegend: React.FC<ChartLegendProps> = ({
  items,
  dotSize = 12,
  fontSize = 12,
  spaceBetween = false,
}) => (
  <LegendContainer className={classNames('', { 'space-between': spaceBetween })}>
    {items.map((item) => (
      <Stack key={item.label} direction="row" alignItems="center">
        <ColorDot color={item.color} size={dotSize} />
        <Typography sx={{ fontSize: fontSize }}>{item.label}</Typography>
      </Stack>
    ))}
  </LegendContainer>
);
